var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33682 7.00021L12.3752 2.96178L13.2081 2.12898C13.3309 2.00612 13.3309 1.80648 13.2081 1.68363L12.317 0.792546C12.1941 0.669693 11.9945 0.669693 11.8716 0.792546L7.00039 5.66378L2.12916 0.792153C2.0063 0.669299 1.80667 0.669299 1.68381 0.792153L0.792336 1.68324C0.669482 1.80609 0.669482 2.00573 0.792336 2.12858L5.66396 7.00021L0.792336 11.8714C0.669482 11.9943 0.669482 12.1939 0.792336 12.3168L1.68342 13.2079C1.80627 13.3307 2.00591 13.3307 2.12876 13.2079L7.00039 8.33664L11.0388 12.3751L11.8716 13.2079C11.9945 13.3307 12.1941 13.3307 12.317 13.2079L13.2081 12.3168C13.3309 12.1939 13.3309 11.9943 13.2081 11.8714L8.33682 7.00021Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlue);
export default __webpack_public_path__ + "static/media/CloseBlue.8bc4d484df805af9666ce2889d9f7b95.svg";
export { ForwardRef as ReactComponent };